import React, { useEffect, useRef } from 'react';
import { Button, Grid, Typography } from '@mui/material';

interface FlightOptionProps {
	isSelected: boolean;
	flightIndex: number;
	handleFlightSelectionChange?: (index: number) => void;
}

export function FlightOption({ isSelected, flightIndex, handleFlightSelectionChange }: FlightOptionProps): JSX.Element {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isSelected && ref.current) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				inline: 'center',
				block: 'nearest',
			});
		}
	}, [isSelected]);

	return (
		<Grid sx={{ display: 'flex', alignItems: 'stretch' }} item ref={isSelected ? ref : null}>
			<Button
				size="small"
				sx={{
					width: '190px',
					overflow: 'hidden',
					height: '42px',
					justifyContent: 'flex-start',
					textAlign: 'left',
					borderRadius: '10px',
					borderWidth: isSelected ? '2px' : '1px',
					backgroundColor: isSelected ? 'rgba(49, 25, 75, 0.08)' : 'rgba(255, 255, 255, 0.90)',
					boxShadow: isSelected ? '0 4px 14px rgba(49, 25, 75, 0.16)' : 'none',
					borderColor: isSelected ? 'primary.main' : 'rgba(49, 25, 75, 0.18)',
				}}
				variant="outlined"
				onClick={() => handleFlightSelectionChange && handleFlightSelectionChange(flightIndex)}
			>
				<Typography
					fontSize={12}
					fontWeight={isSelected ? 'bold' : 500}
					minHeight="34px"
					display="flex"
					flexDirection="column"
					alignItems="flex-start"
					justifyContent="center"
					minWidth="150px"
					component="p"
				>
					{isSelected && (
						<Typography component="span" fontSize={9} color="secondary" fontWeight={800} lineHeight={1}>
							Seleccionado
						</Typography>
					)}
					Opción {flightIndex + 1}
				</Typography>
			</Button>
		</Grid>
	);
}
